/**
 * The top-level views the app swaps between (there is no vue-router — App.vue
 * drives a single `currentView` state and AppShell's rail sets it). Every
 * view is a real surface now; PLACEHOLDERS stays as the seam for any future
 * not-yet-built destination.
 */
export type View = 'home' | 'dashboards' | 'metrics' | 'logs' | 'traces' | 'alerts' | 'settings';

/** Human title shown in the topbar per view. */
export const VIEW_TITLE: Record<View, string> = {
  home: 'Home',
  dashboards: 'Dashboards',
  metrics: 'Metrics',
  logs: 'Logs',
  traces: 'Traces',
  alerts: 'Alerts',
  settings: 'Settings',
};

export interface PlaceholderMeta {
  title: string;
  icon: unknown;
  blurb: string;
}

/** Metadata for not-yet-built surfaces, rendered by PlaceholderView.
 * Currently empty — every rail destination is a real view. */
export const PLACEHOLDERS: Partial<Record<View, PlaceholderMeta>> = {};
